// frontend/src/components/Test/SerieDescanso.js
//
// Pantalla de descanso entre series de Terman: se muestra al terminar cada
// serie (excepto antes de la Serie I, que ya tiene su propia pantalla de
// instrucciones general) con las instrucciones de la siguiente serie. El
// candidato debe confirmar para arrancar el temporizador de la nueva serie.
// También sirve como punto de reanudación: si se pierde la conexión aquí,
// al volver se muestra esta misma pantalla en vez de repetir preguntas.

import React from 'react';

const SerieDescanso = ({ serieCompletada, siguienteSerie, totalSeries, onContinuar }) => {
  return (
    <div className="test-instructions-container">
      <div className="instructions-card">
        <img src="/Logotransparente.png" alt="Logo" className="logo-img" />

        <div className="descanso-check">✅</div>
        <h1>¡Serie {serieCompletada?.nombre_serie} completada!</h1>

        <div className="tests-info">
          <ul>
            <li>
              <strong>
                Siguiente: Serie {siguienteSerie.nombre_serie}
                {siguienteSerie.descripcion ? ` — ${siguienteSerie.descripcion}` : ''}
              </strong>
              <p>{siguienteSerie.instrucciones || 'Lee cada pregunta con cuidado y selecciona la opción que consideres correcta.'}</p>
              {siguienteSerie.tiempo_limite_segundos > 0 && (
                <small>Tiempo límite: {Math.ceil(siguienteSerie.tiempo_limite_segundos / 60)} minutos</small>
              )}
            </li>
          </ul>
        </div>

        <div className="instructions-content">
          <ul>
            <li>Tómate un momento antes de continuar; el tiempo de esta serie empieza a correr hasta que presiones el botón.</li>
            <li>Si cierras el navegador o pierdes la conexión ahora, podrás retomar exactamente en esta pantalla.</li>
          </ul>
        </div>

        <div className="descanso-progreso">
          Serie {siguienteSerie.orden || ''} de {totalSeries}
        </div>

        <div className="test-actions">
          <button onClick={onContinuar} className="btn-start">
            Comenzar Serie {siguienteSerie.nombre_serie}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SerieDescanso;
